import React from "react";

const AdditionalInfo = ({weight}) => {
  return (
    <div className="mt-12 animate-slide-in">
      <h2 className="text-2xl font-bold mb-4 text-orange-500">
        Additional Information
      </h2>
      <ul className="text-gray-700 space-y-2">
        <li>
          <strong>Weight:</strong> {weight*1000}g
        </li>
        <li>
          <strong>Ingredients:</strong> 100% Pure Organic Honey
        </li>
        <li>
          <strong>Shelf Life:</strong> 24 months
        </li>
        <li>
          <strong>Storage:</strong> Store in a cool, dry place away from
          sunlight.
        </li>
      </ul>
    </div>
  );
};

export default AdditionalInfo;
